import React from 'react';
import { FilledButton } from '@make-software/tg-mini-app-ui';

import { RoundActivityCard } from '@/shared';

import { DecoratedVoteActivity } from '../useScreen';
import { Container } from '../styled';
import { EmptyRound } from './empty-round';

interface ActivityListProps {
  items?: DecoratedVoteActivity[];
  round: number;
  hasMore: boolean;
  onLoadMore: () => void;
}

export const ActivityList: React.FC<ActivityListProps> = ({
  items,
  round,
  hasMore,
  onLoadMore
}) => {
  return (
    <Container gap={10}>
      {items?.length ? (
        items.map((activity) => (
          <RoundActivityCard
            key={activity.id}
            projectName={activity?.project_title ?? `Project ${activity?.id}`}
            projectLogo={activity?.project_logo?.url}
            activity={activity}
            earnIconFill={round === 1 ? '#FB6F6A' : '#A0B3FF'}
          />
        ))
      ) : (
        <EmptyRound round={round} />
      )}

      {hasMore && <FilledButton title="Load more" onClick={onLoadMore} fontFamily="Inter" />}
    </Container>
  );
};
